import { WalletIcon, WorkflowIcon, GitBranchIcon, MonitorIcon } from 'lucide-react';
import type { NavigationSectionConfig } from './types';

/**
 * Development Navigation Section
 * Mock Payment API, Batch Management, State Machine Demo, Process Manager
 */
export const developmentSections: NavigationSectionConfig[] = [
  {
    id: 'development-section',
    label: 'Development',
    topNavId: 'development',
    items: [
      {
        id: 'mock-payment-api',
        label: 'Mock Payment',
        path: '/dev/mock-payment-api',
        icon: <WalletIcon size={18} />,
        permissions: ['nav:mock-payment']
      },
      {
        id: 'batch-management',
        label: 'Batch Management',
        path: '/insurance/batch-management',
        icon: <WorkflowIcon size={18} />,
        permissions: ['nav:batch-management']
      },
      {
        id: 'state-machine-demo',
        label: 'State Demo',
        path: '/state-machine-demo',
        icon: <GitBranchIcon size={18} />,
        permissions: ['nav:state-demo']
      },
      {
        id: 'process-manager-dashboard',
        label: 'Process Manager',
        path: '/admin/processes',
        icon: <MonitorIcon size={18} />,
        permissions: ['nav:process-manager']
      }
    ]
  }
];

